// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Entry-module__root--iRutQ {
  --entry-line-color: var(--chaek-color-border-divider);

  gap: 14px;
  display: flex;
  flex-direction: column;
}

.Entry-module__ui-Entry--KaF__ + .Entry-module__ui-Entry--KaF__ {
  /* border-bottom: 8px solid #F1E9DE; */
  margin-top: 16px;
}

.Entry-module__ui-Entry-Main--IKlUI {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  justify-content: space-between;
  align-items: flex-start;
}

.Entry-module__spacing-medium--LFRQV {
  --entry-line-inset: 22px;

  padding: 20px 22px;
}

.Entry-module__spacing-large--yGImU {
  --entry-line-inset: 32px;

  padding: 32px;
}

.Entry-module__ui-Entry-Header--xUoqe {
  width: 100%;
}

.Entry-module__ui-Entry-Body--MYL9Y {
  white-space: pre-wrap;
  width: 100%;
  gap: 12px;
  flex: 1;
}

.Entry-module__ui-Entry-Footer--oySzm {
  display: block;
  width: 100%;
  text-align: right;
}

.Entry-module__ui-Entry-Extension--nxnqv {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-left: 24px;
  /* background: #F7F2EC; */
}

.Entry-module__line-top--eS03s {
  border-top: 1px solid var(--entry-line-color);
}

.Entry-module__line-top-inset--ua7l8 {
  position: relative;
}

.Entry-module__line-top-inset--ua7l8::before {
  position: absolute;
  top: 0;
  right: var(--entry-line-inset);
  left: var(--entry-line-inset);
  border-top: 1px solid var(--entry-line-color);
  content: '';
}

.Entry-module__line-bottom--HWmTL {
  border-bottom: 1px solid var(--entry-line-color);
}

.Entry-module__line-bottom-inset--oDAwZ {
  position: relative;
}

.Entry-module__line-bottom-inset--oDAwZ::after {
  position: absolute;
  right: var(--entry-line-inset);
  bottom: 0;
  left: var(--entry-line-inset);
  border-bottom: 1px solid var(--entry-line-color);
  content: '';
}

.Entry-module__is-reverse--gkvb6 {
  --entry-line-color: rgba(255, 255, 255, 0.05);

  color: #ffffff;
}

.Entry-module__is-reverse--gkvb6 .Entry-module__ui-Entry-Main--IKlUI {
  background-color: transparent;
}

.Entry-module__is-reverse--gkvb6 .Entry-module__ui-Entry-Body--MYL9Y {
  color: #E2E2E2
} 
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Entry/Entry.module.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;;EAErD,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;;EAExB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;;EAExB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,8BAA8B;EAC9B,6BAA6B;EAC7B,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,6CAA6C;;EAE7C,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;AACF","sourcesContent":[".root {\n  --entry-line-color: var(--chaek-color-border-divider);\n\n  gap: 14px;\n  display: flex;\n  flex-direction: column;\n}\n\n.ui-Entry + .ui-Entry {\n  /* border-bottom: 8px solid #F1E9DE; */\n  margin-top: 16px;\n}\n\n.ui-Entry-Main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.spacing-medium {\n  --entry-line-inset: 22px;\n\n  padding: 20px 22px;\n}\n\n.spacing-large {\n  --entry-line-inset: 32px;\n\n  padding: 32px;\n}\n\n.ui-Entry-Header {\n  width: 100%;\n}\n\n.ui-Entry-Body {\n  white-space: pre-wrap;\n  width: 100%;\n  gap: 12px;\n  flex: 1;\n}\n\n.ui-Entry-Footer {\n  display: block;\n  width: 100%;\n  text-align: right;\n}\n\n.ui-Entry-Extension {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-left: 24px;\n  /* background: #F7F2EC; */\n}\n\n.line-top {\n  border-top: 1px solid var(--entry-line-color);\n}\n\n.line-top-inset {\n  position: relative;\n}\n\n.line-top-inset::before {\n  position: absolute;\n  top: 0;\n  right: var(--entry-line-inset);\n  left: var(--entry-line-inset);\n  border-top: 1px solid var(--entry-line-color);\n  content: '';\n}\n\n.line-bottom {\n  border-bottom: 1px solid var(--entry-line-color);\n}\n\n.line-bottom-inset {\n  position: relative;\n}\n\n.line-bottom-inset::after {\n  position: absolute;\n  right: var(--entry-line-inset);\n  bottom: 0;\n  left: var(--entry-line-inset);\n  border-bottom: 1px solid var(--entry-line-color);\n  content: '';\n}\n\n.is-reverse {\n  --entry-line-color: rgba(255, 255, 255, 0.05);\n\n  color: #ffffff;\n}\n\n.is-reverse .ui-Entry-Main {\n  background-color: transparent;\n}\n\n.is-reverse .ui-Entry-Body {\n  color: #E2E2E2\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Entry-module__root--iRutQ`,
	"ui-Entry": `Entry-module__ui-Entry--KaF__`,
	"ui-Entry-Main": `Entry-module__ui-Entry-Main--IKlUI`,
	"spacing-medium": `Entry-module__spacing-medium--LFRQV`,
	"spacing-large": `Entry-module__spacing-large--yGImU`,
	"ui-Entry-Header": `Entry-module__ui-Entry-Header--xUoqe`,
	"ui-Entry-Body": `Entry-module__ui-Entry-Body--MYL9Y`,
	"ui-Entry-Footer": `Entry-module__ui-Entry-Footer--oySzm`,
	"ui-Entry-Extension": `Entry-module__ui-Entry-Extension--nxnqv`,
	"line-top": `Entry-module__line-top--eS03s`,
	"line-top-inset": `Entry-module__line-top-inset--ua7l8`,
	"line-bottom": `Entry-module__line-bottom--HWmTL`,
	"line-bottom-inset": `Entry-module__line-bottom-inset--oDAwZ`,
	"is-reverse": `Entry-module__is-reverse--gkvb6`
};
export default ___CSS_LOADER_EXPORT___;
